import { render, staticRenderFns } from "./ResearchOrderAdmin.vue?vue&type=template&id=982fba34&scoped=true&"
import script from "./ResearchOrderAdmin.vue?vue&type=script&lang=js&"
export * from "./ResearchOrderAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOrderAdmin.vue?vue&type=style&index=0&id=982fba34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982fba34",
  null
  
)

export default component.exports